var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errorCode)?_c('error-message',{attrs:{"errorCode":_vm.errorCode}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }